import type { BlandFunnel, BlandLoOutcome } from '../types/voip';

/** 30-day AI dialer totals across all loan officers */
export const blandFunnel30: Pick<BlandFunnel, 'dials' | 'pickedUp'> = {
  dials: 21480,
  pickedUp: 5262,
};

/** 30-day live transfers each loan officer received from Bland */
export const blandLoOutcomes: BlandLoOutcome[] = [
  { agentId: 'a1', transfers: 132, opportunities: 41 },
  { agentId: 'a2', transfers: 98, opportunities: 24 },
  { agentId: 'a3', transfers: 76, opportunities: 19 },
  { agentId: 'a4', transfers: 64, opportunities: 13 },
  { agentId: 'a5', transfers: 112, opportunities: 36 },
  { agentId: 'a6', transfers: 71, opportunities: 15 },
  { agentId: 'a7', transfers: 58, opportunities: 17 },
  { agentId: 'a8', transfers: 104, opportunities: 31 },
  { agentId: 'a9', transfers: 141, opportunities: 46 },
  { agentId: 'a10', transfers: 49, opportunities: 9 },
  { agentId: 'a11', transfers: 82, opportunities: 22 },
  { agentId: 'a12', transfers: 95, opportunities: 27 },
];
